import type { FC } from 'react'
import { Typography } from '@mui/material'
import { ProfileViewAlertContainer } from './ProfileViewAlertContainer'

export const ConnectedAtAlert: FC<{ connectedAt: string }> = ({ connectedAt }) => {
  return (
    <ProfileViewAlertContainer variant="warning">
      <Typography variant="body2">
        {connectedAt}にInstagram連携を開始しました。それ以前のデータは表示されません。
      </Typography>
    </ProfileViewAlertContainer>
  )
}
